import * as actionTypes from "./actionTypes";
import { selectMember, smsTokenStart, smsTokenStop } from "./member";
import admSvc from "../../axios-admsvc";
import { startTimer } from "./timer";
import {
  LS_OTP_VERIFIED,
  LS_OTP_VERIFIED_NUMBER,
  LS_DISABLE_IDENTITY_ATTEST_FAIL,
  SDK_ENABLE,
  NO_RECOVERY_OPTIONS_AVAILABLE,
  SUCCESS,
  INFO,
  DISABLE_REASONS,
  DISABLE_SUCCESS,
  CHECK_BRIOVA_PRTL_SHORTNAME_FLAG,
  SDK_PORTAL_LIST,
  OPTUMLABSLOOP,
  ID_TYPE_NEW,
  SESSION_USERNAME,
  SESSION_TIER1USER,
} from "../../shared/Constants";

export const generateSmsOtpTokenIc = (userData, otpType, origin, identityConfirmationFlow) => {
  return (dispatch) => {
    dispatch(smsTokenLoading());
    admSvc
      .post(
        otpType === "Phone" ? "/members/otp/sms" : "/members/otp/call",
        userData,
        {
          headers: {
            NewUI: "Yes",
            "IdentityConfirmationFlow": identityConfirmationFlow,
          }
        }
      )
      .then((response) => {
        //console.log("[Member Actions] generateSmsOtpToken: response", response.data);
        if (response.data.sessionid) {
          dispatch(smsOtpTokenSuccess(response.data, otpType, origin));
          dispatch(setOtpGeneratedFlag(false));
        } else if (response.data.error.includes("is locked")) {
          dispatch(
            smsOtpTokenFailure(
              "Cannot generate code, please unlock RBA to proceed.", origin,
            ),
          );
        } else if (
          response.data.error == "Country code or phone number is missing"
        ) {
          dispatch(
            smsOtpTokenFailure(
              "Country code and phone number are mandatory to generate OTP", origin,
            ),
          );
        } else {
          dispatch(
            smsOtpTokenFailure(
              "Passcode cannot be generated. Please Try Again. If issue persists, please contact L.1.5 for further assistance.", origin,
            ),
          );
        }
      })
      .catch((error) => {
        //console.log("Generate OTP TOken error response: ", error);
        dispatch(
          smsOtpTokenFailure(
            "Passcode cannot be generated. Please Try Again. If issue persists, please contact L.1.5 for further assistance.", origin,
          ),
        );
      })
      .finally(() => {
        dispatch(smsTokenLoading());
      });
  };
};

export const smsOtpTokenSuccess = (genTokenResponse, otpType, origin) => {
  return {
    type: actionTypes.SMS_OTP_TOKEN_SUCCESS_IC,
    genTokenResponse: genTokenResponse,
    otpType,
    origin,
  };
};

export const smsOtpTokenFailure = (error, origin) => {
  return {
    type: actionTypes.SMS_OTP_TOKEN_FAILURE_IC,
    error: error,
    origin,
  };
};

export const setOtpGeneratedFlag = (flag) => {
  return {
    type: actionTypes.OTP_GENERATED_FLAG_IC,
    flag: flag,
  };
};

export const resetOtpGeneratedMessage = () => {
  return {
    type: actionTypes.OTP_GENERATED_MESSAGE_RESET_IC,
  };
};

export const resetTempGenerateOtpMessage = () => {
  return {
    type: actionTypes.TEMP_GENERATE_OTP_MESSAGE_RESET_IC,
  };
};

export const smsTokenLoading = () => {
  return {
    type: actionTypes.SMS_OTP_TOKEN_LOADER_IC,
  };
};

// verify flow
export const verifySmsOtpTokenIc = (userData, essoDetails, identityConfirmationFlow) => {
  return (dispatch) => {
    dispatch(smsTokenLoading());
    admSvc
      .post("/members/otp/verifyToken", userData, {
        headers: {
          NewUI: "Yes",
          "IdentityConfirmationFlow": identityConfirmationFlow,
        }
      })
      .then((response) => {
        //console.log("[Member Actions] verifySmsOtpToken: response", response.data);
        if (
          response.data &&
          response.data.authenticationStatus &&
          response.data.authenticationStatus === "AUTHENTICATED"
        ) {
          if (
            response.data.identityAssociationResponse &&
            (response.data.identityAssociationResponse.result === "PASS" || response.data.identityAssociationResponse.result === "SKIPPED")
          ) {
            //if the otp is verified via email we store encrypted Id in the local storage to keep it alive even after reload
            localStorage.setItem(
              LS_OTP_VERIFIED,
              btoa(response.data.uuid ?? essoDetails.uuid),
            );
            localStorage.setItem(
              LS_OTP_VERIFIED_NUMBER,
              btoa(
                JSON.stringify({
                  countryCode: userData.countryCode,
                  number: userData.phoneno,
                }),
              ),
            );
            dispatch(startTimer());
            dispatch(selectMember(essoDetails, essoDetails.idType, false));
            dispatch(
              verifyOtpTokenSuccess(
                response.data.identityAssociationResponse.result === "SKIPPED" ? "" : "Identity verification passed",
                "OTP Verified",
              ),
            );
            // dispatch(initiateAttestFailure())
          } else {
            // dispatch(selectMember(essoDetails, essoDetails.idType, false));
            const isDifferentNumber =
              userData.phoneno !== essoDetails.phoneno ||
              userData.countryCode !== essoDetails.countryCode;
            dispatch(
              verifyOtpTokenFailure(
                "Identity verification failed",
                "OTP Verified",
              ),
            );
            // if(!isDifferentNumber) {
            //   dispatch(initiateAttestSuccess())
            // }
          }
          dispatch(setOtpGeneratedFlag(true));
        } else {
          if (
            response.data &&
            response.data.error &&
            response.data.error.includes("The user is locked")
          ) {
            dispatch(selectMember(essoDetails, essoDetails.idType, false));
            dispatch(
              verifyOtpTokenFailure(
                "",
                "Failed to authenticate user with SMS.The user is locked",
              ),
            );
          } else if (
            response.data &&
            response.data.error &&
            response.data.error.includes("The user is disabled")
          ) {
            dispatch(selectMember(essoDetails, essoDetails.idType, false));
            dispatch(
              verifyOtpTokenFailure(
                "",
                "Failed to authenticate user with SMS.The user is disabled",
              ),
            );
          } else {
            dispatch(verifyOtpTokenFailure("", "Wrong Passcode"));
          }
          //   dispatch(initiateAttestFailure())
        }
      })
      .catch((error) => {
        //console.log("Verify OTP TOken error response: ", error);
        dispatch(verifyOtpTokenFailure("", "Wrong Passcode"));
      })
      .finally(() => {
        dispatch(smsTokenLoading());
      });
  };
};

export const verifyOtpTokenSuccess = (tmxMessage, otpMessage) => {
  return {
    type: actionTypes.VERIFY_OTP_TOKEN_SUCCESS_IC,
    tmxMessage: tmxMessage,
    otpMessage: otpMessage,
  };
};

export const verifyOtpTokenFailure = (error, otpMessage) => {
  return {
    type: actionTypes.VERIFY_OTP_TOKEN_FAILURE_IC,
    error: error,
    otpMessage,
  };
};

// dbic flow
export const getDbicDetailsIc = (userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow) => {
  return (dispatch) => {
    dispatch(smsTokenLoading());
    admSvc
      .post("/dbic/status-details", userData, {
        headers: {
          NewUI: "Yes",
          "IdentityConfirmationFlow": identityConfirmationFlow,
        }
      })
      .then((response) => {
        // console.log("[Member Actions] getDbicDetails: response", response.data);
        if (response.data.status?.code === "200") {
          dispatch(getDbicPdbSuccess(response.data.payload));
          const {
            requestId,
            idVerseTransactionId,
            uuid,
            phone,
            countryCode,
          } = response.data.payload;
          if (requestId) {
            const body = {
              requestId,
              idVerseTransactionId,
              uuid,
              phone,
              countryCode,
              firstName: userData.firstName,
              lastName: userData.lastName,
              dateOfBirth: userData.dateOfBirth,
              email: userData.email,
              username: essoDetails.userName,
            }
            dispatch(getIdverseResultsIc(body, essoDetails, reuseFlow, poaData, identityConfirmationFlow));
          }
        }
      })
      .catch((error) => {
        //console.log("Verify OTP TOken error response: ", error);
        dispatch(getDbicPdbFailure());
      })
      .finally(() => {
        dispatch(smsTokenLoading());
      });
  };
};

export const getIdverseResultsIc = (userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow) => {
  return (dispatch) => {
    dispatch(smsTokenLoading());
    const getResults = (attempt) => {
      return admSvc
        .post("/dbic/idverse/results", userData, {
          headers: {
            NewUI: "Yes",
            "IdentityConfirmationFlow": identityConfirmationFlow,
          }
        })
        .then((response) => {
        // console.log("[Member Actions] getIdverseResultsIc: response", response.data);
        if (response.data.status?.code === "200") {
          const status = response.data?.payload?.auditData?.status;
          const timestamp = response.data?.payload?.auditData?.timestamp;
          const reviewStatus = response.data?.payload?.reviewStatus;
          if (status === "EXPIRED") {
            dispatch(getIdverseResultsFailure("Link expired please start new DBIC."));
          } else if (status === "COMPLETED_PASS" && reviewStatus === 'PASS') {
            handleSuccess(dispatch, userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow);
            dispatch(getIdverseResultsFailure("", timestamp));
          } else if (status === "COMPLETED_PASS" && reviewStatus === 'REJECT') {
            const data = {
              uuid: userData.uuid,
              phoneno: userData.phone,
              username: essoDetails.userName,
              countryCode: userData.countryCode,
              event: "DOCUMENT_BASED_ID_CONFIRMATION",
              eventStatus: "FAILURE",
              failureReason: "DBIC Reject",
              newData: {
                RequestId: " " + userData.requestId,
                IdVerseTransactionId: " " + userData.idVerseTransactionId,
                "ReuseFlow": reuseFlow ? "Yes" : "No",
                ...(poaData ? {
                  Firstname: poaData.firstName,
                  Lastname: poaData.lastName,
                  DOB: poaData.dob
                } : {}),
                NewUI: "Yes",
                "IdentityConfirmationFlow": identityConfirmationFlow,
              }
            };
            dispatch(pushtoActivityLog(data, essoDetails));
            dispatch(getIdverseResultsFailure(""));
          } else {
            dispatch(startPolling());
          }
        } else {
          if (attempt === 0) {
            return getResults(1);
          }
          dispatch(getIdverseResultsFailure("", null, true));
        }
        })
        .catch((error) => {
          //console.log("Verify OTP TOken error response: ", error);
          if (attempt === 0) {
            return getResults(1);
          }
          dispatch(getIdverseResultsFailure("", null, true));
        });
    };

    getResults(0).finally(() => {
        dispatch(smsTokenLoading());
      });
  };
};

export const getDbicPdbSuccess = (response) => {
  return {
    type: actionTypes.GET_DBIC_PDB_SUCCESS_IC,
    dbicData: response,
  };
};

export const getDbicPdbFailure = () => {
  return {
    type: actionTypes.GET_DBIC_PDB_FAILURE_IC,
  };
};

export const startPolling = () => {
  return {
    type: actionTypes.START_POLLING_IC,
  };
};

export const resetDbicStatus = () => {
  return {
    type: actionTypes.RESET_DBIC_STATUS_IC,
  };
};

export const sendDbicLinkIc = (userData, identityConfirmationFlow) => {
  return (dispatch) => {
    dispatch(smsTokenLoading());
    admSvc
      .post("/dbic/challenge", userData, {
        headers: {
          NewUI: "Yes",
          "IdentityConfirmationFlow": identityConfirmationFlow,
        }
      })
      .then((response) => {
        // console.log("[Member Actions] sendDbicLink: response", response.data);
        if (response.data.payload.status === "SUCCESS") {
          dispatch(sendDbicLinkSuccess(response.data.payload, "Verification link sent successfully"));
        } else {
          dispatch(sendDbicLinkFailure("Unable to send DBIC link. Please try again after a few seconds."));
        }
      })
      .catch((error) => {
        //console.log("Verify OTP TOken error response: ", error);
        dispatch(sendDbicLinkFailure("Unable to send DBIC link. Please try again after a few seconds."));
      })
      .finally(() => {
        dispatch(smsTokenLoading());
      });
  };
};

export const reSendDbicLinkIc = (userData, identityConfirmationFlow) => {
  return (dispatch) => {
    dispatch(smsTokenLoading());
    admSvc
      .post("/dbic/link", userData, {
        headers: {
          NewUI: "Yes",
          "IdentityConfirmationFlow": identityConfirmationFlow,
        }
      })
      .then((response) => {
        if (response.data.payload.status === "SUCCESS") {
          dispatch(reSendDbicLinkSuccess(response.data.payload, "Verification link sent successfully"));
        } else {
          dispatch(reSendDbicLinkFailure("Unable to re-send DBIC link. Please try again."));
        }
      })
      .catch((error) => {
        //console.log("Verify OTP TOken error response: ", error);
        dispatch(reSendDbicLinkFailure("Unable to re-send DBIC link. Please try again."));
      })
      .finally(() => {
        dispatch(smsTokenLoading());
      });
  };
};

const handleSuccess = (dispatch, userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow) => {
  localStorage.setItem(
    LS_OTP_VERIFIED,
    btoa(userData.uuid),
  );
  localStorage.setItem(
    LS_OTP_VERIFIED_NUMBER,
    btoa(
      JSON.stringify({
        countryCode: userData.countryCode,
        number: userData.phone,
      }),
    ),
  );
  dispatch(startTimer());
  dispatch(selectMember(essoDetails, essoDetails.idType, false));
  const data = {
    uuid: userData.uuid,
    phoneno: userData.phone,
    username: essoDetails.userName,
    countryCode: userData.countryCode,
    event: "DOCUMENT_BASED_ID_CONFIRMATION",
    eventStatus: "SUCCESS",
    newData: {
      RequestId: " " + userData.requestId,
      IdVerseTransactionId: " " + userData.idVerseTransactionId,
      "ReuseFlow": reuseFlow ? " Yes" : " No",
      ...(poaData ? {
        Firstname: poaData.firstName,
        Lastname: poaData.lastName,
        DOB: poaData.dob
      } : {}),
      NewUI: "Yes",
      "IdentityConfirmationFlow": identityConfirmationFlow,
    }
  };
  dispatch(pushtoActivityLog(data, essoDetails))
}

export const pollDbic = (userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow) => {
  return (dispatch) => {
    // dispatch(smsTokenLoading());
    return admSvc
      .post("/dbic/status/poll", userData, {
        headers: {
          NewUI: "Yes",
          "IdentityConfirmationFlow": identityConfirmationFlow,
        }
      })
      .then((response) => {
        // console.log("[Member Actions] pollDbic: response", response.data);
        if (response.data.payload?.docVerificationStatus === "PASS") {
          handleSuccess(dispatch, userData, essoDetails, reuseFlow, poaData, identityConfirmationFlow);
          dispatch(dbicPollingSuccess());
        } else if (response.data.payload?.docVerificationStatus === "REJECT") {
          const data = {
            uuid: userData.uuid,
            phoneno: userData.phone,
            username: essoDetails.userName,
            countryCode: userData.countryCode,
            event: "DOCUMENT_BASED_ID_CONFIRMATION",
            eventStatus: "FAILURE",
            failureReason: "DBIC Reject",
            newData: {
              RequestId: " " + userData.requestId,
              IdVerseTransactionId: " " + userData.idVerseTransactionId,
              "ReuseFlow": reuseFlow ? "Yes" : "No",
              ...(poaData ? {
                Firstname: poaData.firstName,
                Lastname: poaData.lastName,
                DOB: poaData.dob
              } : {}),
              NewUI: "Yes",
              "IdentityConfirmationFlow": identityConfirmationFlow,
            }
          };
          dispatch(pushtoActivityLog(data, essoDetails))
          dispatch(dbicPollingFailure("DBIC polling failed."));
        }
        return response.data;
      })
      .catch((error) => {
        //console.log("Verify OTP TOken error response: ", error);
        // dispatch(dbicPollingFailure("DBIC polling failed."));
      })
      .finally(() => {
        // dispatch(smsTokenLoading());
      });
  };
};

export const dbicPollingSuccess = () => {
  return {
    type: actionTypes.DBIC_POLLING_SUCCESS_IC,
  };
};

export const dbicPollingFailure = (error, timeout = null) => {
  return {
    type: actionTypes.DBIC_POLLING_FAILURE_IC,
    error,
    timeout,
  };
};

export const sendDbicLinkSuccess = (response, message) => {
  return {
    type: actionTypes.SEND_DBIC_LINK_SUCCESS_IC,
    dbicData: response,
    message,
  };
};

export const sendDbicLinkFailure = (error) => {
  return {
    type: actionTypes.SEND_DBIC_LINK_FAILURE_IC,
    error,
  };
};

export const reSendDbicLinkSuccess = (response, message) => {
  return {
    type: actionTypes.RESEND_DBIC_LINK_SUCCESS_IC,
    dbicData: response,
    message,
  };
};

export const reSendDbicLinkFailure = (error) => {
  return {
    type: actionTypes.RESEND_DBIC_LINK_FAILURE_IC,
    error,
  };
};

export const getIdverseResultsSuccess = (message) => {
  return {
    type: actionTypes.GET_IDVERSE_RESULTS_SUCCESS_IC,
    message,
  };
};

export const getIdverseResultsFailure = (message, timestamp, hasApiFailed) => {
  return {
    type: actionTypes.GET_IDVERSE_RESULTS_FAILURE_IC,
    message,
    timestamp,
    hasApiFailed,
  };
};

export const resetReSendDbicLinkMessage = () => {
  return {
    type: actionTypes.RESET_RESEND_DBIC_LINK_MESSAGE_IC,
  };
};

export const resetSendDbicLinkMessage = () => {
  return {
    type: actionTypes.RESET_SEND_DBIC_LINK_MESSAGE_IC,
  };
};

export const resetExpiredLinkMessage = () => {
  return {
    type: actionTypes.RESET_EXPIRED_LINK_MESSAGE_IC,
  };
};

// 2 step flow

export const initiateAttestIc = (data, essoData, userType, identityConfirmationFlow) => {
  return (dispatch) => {
    admSvc.post("/activity/event", data, {
      headers: {
        NewUI: "Yes",
        "IdentityConfirmationFlow": identityConfirmationFlow,
      }
    })
      .then((res) => {
        if (data.eventStatus === 'SUCCESS') {
          localStorage.setItem(LS_OTP_VERIFIED, btoa(data.uuid));
          localStorage.setItem(LS_OTP_VERIFIED_NUMBER, btoa(JSON.stringify({ countryCode: data.countryCode, number: data.phoneno })));
          dispatch(selectMember(essoData, essoData.idType, false))
          dispatch(initiateAttestFailure())
          //   dispatch(verifyOtpTokenSuccess(userType===SESSION_TIER1USER ? "2-Step Process Attested to, update fields unlocked" :""));
        } else {
          dispatch(initiateAttestFailure())
          localStorage.setItem(LS_DISABLE_IDENTITY_ATTEST_FAIL, btoa(data.uuid));
          //   dispatch(verifyOtpTokenFailure(userType===SESSION_TIER1USER ? '2-Step Process Failed, please warm transfer to T1.5':""))
        }

      })
      .catch((e) => {
        dispatch(initiateAttestFailure())
      })
  }
}

export const pushtoActivityLog = (data, essoData, identityConfirmationFlow) => {
  return (dispatch) => {
    admSvc.post("/activity/event", data, {
      headers: {
        NewUI: "Yes",
        "IdentityConfirmationFlow": identityConfirmationFlow,
      }
    })
      .then((res) => {
      })
      .catch((e) => {
      })
  }
}

export const initiateAttestSuccess = () => {
  return {
    type: actionTypes.INITIATE_ATTEST_SUCCESS_IC,
  };
};

export const initiateAttestFailure = () => {
  return {
    type: actionTypes.INITIATE_ATTEST_FAILURE_IC,
  };
};

